import { Field, FieldError, FieldLabel, Input } from "@/components/ui";
import { BodyText } from "@/components/ui/Text";
import { TRACKERS } from "@/constants/Trackers";
import { SubmitCancelButtons } from "@/features/Patient/MedicalRecords/components/SubmitCancelButtons";
import { trackEvent } from "@/lib/tracking";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import type { z } from "zod";
import { profilePhoneNumberFormSchema } from "../schemas";

interface UpdatePhoneNumberFormProps {
  handleSubmit: (data: z.infer<typeof profilePhoneNumberFormSchema>) => void;
  phoneNumber: string;
  isUpdatingPhoneNumber: boolean;
  setIsEditingPhoneNumber: (isEditing: boolean) => void;
}

export const UpdatePhoneNumberForm = ({
  handleSubmit,
  phoneNumber,
  isUpdatingPhoneNumber,
  setIsEditingPhoneNumber,
}: UpdatePhoneNumberFormProps) => {
  const form = useForm<z.infer<typeof profilePhoneNumberFormSchema>>({
    resolver: zodResolver(profilePhoneNumberFormSchema),
    defaultValues: {
      phoneNumber,
    },
  });
  return (
    <form
      onSubmit={form.handleSubmit(handleSubmit)}
      className="flex flex-col gap-2 px-3 py-2 w-1/2"
    >
      <div className="flex flex-col">
        <Controller
          control={form.control}
          name="phoneNumber"
          render={({ field, fieldState }) => (
            <Field>
              <FieldLabel htmlFor="phoneNumber">
                <BodyText size="sm" bold>
                  Phone Number
                </BodyText>
              </FieldLabel>
              <Input {...field} id="phoneNumber" autoFocus />
              <FieldError errors={[fieldState.error]} />
            </Field>
          )}
        />
      </div>
      <SubmitCancelButtons
        isSaving={isUpdatingPhoneNumber}
        onCancel={() => {
          trackEvent(TRACKERS.CANCEL_PHONE_NUMBER);
          setIsEditingPhoneNumber(false);
        }}
        onSave={() => {
          trackEvent(TRACKERS.SAVE_PHONE_NUMBER);
        }}
      />
    </form>
  );
};
